import styled from "styled-components";

export const LoaderStyled = styled.div<{ size?: number; marginTop?: number }>`
  width: auto;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  .absoluteLoader {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: ${(props) => props.size || 70}px;
    height: ${(props) => props.size || 70}px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: ${(props) => (props.marginTop ? `${props.marginTop}px` : "0")};
  }
`;
